<template>
  <div
    class="trackingContainer viewContainer"
    v-if="!this.$store.state.loading"
    :class="{ navBarActive: $store.state.navBar }"
  >
    <Header
      :loading="loading"
      title="Métodos de pago"
      :showSearch="paymentMethod.paymentType == 'card' ? true : false"
      :showNewButton="paymentMethod.paymentType == 'card' ? true : false"
      searchTitle="Buscar tarjeta"
      @add="cardsDialog = true"
    />

    <v-snackbar absolute top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>

    <v-container fluid>
      <v-row>
        <v-col class="user-details" cols="12" sm="8" md="8">
          <p>
            Usuario vinculado:
            <b>{{ userMaster.name }} {{ userMaster.surname }}</b>
          </p>
          <p>
            Número de teléfono: <b>{{ userMaster.phone }}</b>
          </p>
          <p>
            Email: <b>{{ userMaster.email }}</b>
          </p>
          <p>
            Método de pago seleccionado:
            <b>{{ paymentMethod.displayName || "Ninguno" }}</b>
          </p>
        </v-col>
        <!-- <v-col cols="12" sm="4" md="4">
          <v-btn
            color="primary"
            rounded
            class="pa-5 mt-10"
            v-if="paymentMethod.paymentType == 'card'"
            @click="cardsDialog = true"
          >
            Agregar y/o Eliminar Tarjeta
          </v-btn>
        </v-col> -->
      </v-row>

      <v-row v-if="paymentMethod.paymentType == 'card'">
        <v-col cols="12" sm="12">
          <v-data-table
            :headers="headers"
            :items="userCards"
            :items-per-page="10"
            :loading="loading"
            sort-by="name"
            class="mt-5"
            :sort-desc="true"
            :search="searchTerm"
            item-key=".key"
            :footer-props="{
              itemsPerPageOptions: [10, 50, 100],
            }"
          >
            <template v-slot:[`item.validThru`]="{ item }">
              {{ item.validThru | tsToDate }}
            </template>

            <template v-slot:[`item.color`]="{ item }">
              <div
                class="card-color"
                :style="`background-color : ${item.color || ''}`"
              ></div>
            </template>

            <template v-slot:[`item.selected`]="{ item }">
              <v-switch
                @change="setPrincipal($event, item)"
                v-model="item.selected"
                :loading="loading"
              ></v-switch>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog width="600" v-model="cardsDialog">
      <v-card>
        <v-card-title>
          Información
          <v-btn
            style="right: 10px; top: 10px"
            icon
            color="primary"
            fab
            absolute
            @click="cardsDialog = false"
          >
            <v-icon dark style="font-size: 20px">fa-times</v-icon>
          </v-btn></v-card-title
        >

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                class="icons d-none d-md-block d-sm-block"
                cols="12"
                sm="4"
                md="4"
              >
                <i class="fas fa-info-circle"></i>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <h2 style="text-align: justify">
                  Solo el usuario vínculado puede agregar o eliminar tarjetas
                  desde su Dilo Delivery App. Si desea cambiar de usuario vínculado,
                  favor ponerse en contacto con el equipo de Dilo Delivery.
                </h2>
              </v-col>
              <div class="help">
                <i class="fab fa-whatsapp"></i>
                <a
                  href="https://api.whatsapp.com/send?phone=50433248888"
                  target="_blank"
                  >Servicio al Cliente</a
                >
              </div>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <div id="myModal" class="modal" v-if="cardsDialog">
        <div style="margin-top: 10%" class="modal-content">
          <span @click="cardsDialog = false" class="close">&times;</span>
          <div class="payment">
            <h2 style="margin-bottom: 15px">Información</h2>

            <div class="card-main">
              <i class="fas fa-info-circle d-none d-md-block d-sm-block"></i>
              <p>
                Solo el usuario vínculado puede agregar o eliminar tarjetas
                desde su Ocho App. Si desea cambiar de usuario vínculado, favor
                ponerse en contacto con el equipo de Ocho.
              </p>
            </div>
            <div class="help">
              <i class="fab fa-whatsapp"></i>
              <a
                href="https://api.whatsapp.com/send?phone=50433248888"
                target="_blank"
                >Servicio al Cliente</a
              >
            </div>
          </div>
        </div>
      </div> -->
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");
import Header from "@/components/header.vue";

import { mapState } from "vuex";

export default {
  name: "PaymentMethod",
  components: {
    Header,
  },
  data() {
    return {
      business: {},
      loading: true,
      userCards: [],
      cardsDialog: false,
      paymentMethod: "",
      snackbarText: "",
      snackbar: false,
      userMaster: {},
      userNotFound: false,
      headers: [
        { value: "brand", text: "Marca" },
        { value: "color", text: "" },
        { value: "name", text: "Nombre" },
        { value: "endsIn", text: "Termina en" },
        { value: "validThru", text: "Válida hasta" },
        { value: "selected", text: "Tarjeta principal" },
      ],
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      var splitStr = value.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return " " + splitStr.join(" ");
    },
    statusFilter: function (status) {
      switch (status) {
        case "scheduled":
          return "Programada";
          break;

        case "placed":
          return "Colocada";
          break;

        case "assigned":
          return "Asignada";
          break;

        case "enRoute":
          return "En Camino";
          break;

        case "delivered":
          return "Entregada";
          break;

        case "completed":
          return "Completada";
          break;

        case "canceled":
          return "Cancelada";
          break;

        case "rejected":
          return "Rechazada";
          break;

        case "undeliverable":
          return "No Entregada";
          break;

        default:
          return status;
          break;
      }
    },
    tsToDate: function (timestamp) {
      if (!timestamp) return "n/a";
      return moment(timestamp.toDate())
        .tz("America/Tegucigalpa")
        .format("MM/YY");
    },
    tsToRelative: function (timestamp) {
      if (!timestamp) return "n/a";
      return moment(timestamp.toDate())
        .tz("America/Tegucigalpa")
        .format("DD/MM/YYY");
    },
  },
  watch: {
    business(data) {
      this.userCards = this.userCards.map((card) => {
        if (this.business.selectedCard == card[".key"]) {
          card.selected = true;
        } else {
          card.selected = false;
        }
        return card;
      });
      if (this.business.paymentType) {
        this.$binding(
          "paymentMethod",
          db.collection("paymentGateways").doc(this.business.paymentType)
        );
      }
    },
  },
  computed: {
    ...mapState(["searchTerm", "user"]),
  },

  methods: {
    setPrincipal(e, card) {
      let selectedCard = "";
      this.loading = true;

      if (card.selected) {
        selectedCard = card[".key"];
      }
      db.collection("businessesCorporative")
        .doc(this.user.businessID)
        .update({
          selectedCard,
        })
        .then((res) => {
          this.snackbarText = "Información de pago actualizada correctamente.";
          this.snackbar = true;
          this.loading = false;
        })
        .catch((err) => {
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.loading = false;
        });
    },
    async init() {
      await this.$binding(
        "business",
        db.collection(`businessesCorporative`).doc(this.user.businessID)
      );

      if (!this.business.ochoUserId) {
        this.userNotFound = true;
        this.$store.commit("setLoading", false);
        this.loading = false;
        return;
      }

      await this.$binding(
        "userMaster",
        db.collection("users").doc(this.business.ochoUserId)
      );

      await this.$binding(
        "userCards",
        db
          .collection("users")
          .doc(this.business.ochoUserId)
          .collection("cards")
          .where("deleted", "==", false)
      );

      this.userCards.forEach((card) => {
        if (this.business.selectedCard == card[".key"]) {
          card.selected = true;
        }
      });

      this.$store.commit("setLoading", false);
      this.loading = false;
    },
  },
  mounted() {
    if (this.user.role != "admin") {
      return this.$route.push("/map");
    }

    this.$store.commit("setLoading", "Cargando...");
    this.$store.commit("setNavBar", true);

    this.init();
  },
};
</script>

<style lang="scss">
.titleContainer {
  display: flex;
  justify-content: space-between;
  height: 52px;

  h1 {
    font-size: 28px;
    line-height: 28px;
    span {
      font-size: 16px;
      line-height: 16px;
      display: block;
      color: #666;
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;

    .actionBtn {
      appearance: none;
      border: none;
      outline: none;
      margin-left: 10px;
      font-weight: bold;
      color: white;
      text-decoration: none;
      box-sizing: content-box;
      text-align: center;
      padding: 5px;
      min-width: 32px;
      height: 32px;
      border-radius: 18px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      transition: 0.4s 0.1s all cubic-bezier(0.44, 0.1, 0.28, 1.59),
        0.4s 0.5s transform cubic-bezier(0.44, 0.1, 0.28, 1.59);
      color: white;
      background-color: #FF1744;
      box-shadow: 0px 0px 20px rgba(#FF1744, 0.8);
      cursor: pointer;

      &.inactive {
        background-color: #aaa;
        box-shadow: 0px 0px 20px rgba(#333, 0.2);
      }

      i {
        font-size: 21px;
      }

      span {
        margin: 0 15px;
        font-size: 16px;
      }
    }
  }
}

.user-details p {
  margin-top: 20px;
  color: black;
}

.user-cards {
  margin-top: 50px;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
}

.card-main {
  color: black;
  display: grid;
  grid-template-columns: 20% 75%;
  margin-top: 20px;
  align-items: center;

  i {
    font-size: 80px !important;
    color: gray;
  }

  p {
    font-size: 20px;
    text-align: justify;
  }
}

.card-color {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.help {
  margin-top: 30px;
  width: 100%;
  color: #0db317;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    margin-right: 10px;
    color: #0db317;
    font-size: 25px !important;
  }
  a {
    color: #0db317;
    text-decoration: none;
  }
}
.cash-payment {
  width: 100%;
  margin-top: 100px;
  display: flex;
  h2 {
    color: black;
  }
}

.icons {
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    font-size: 90px;
  }
}
</style>

